export default {
  model: [
    {
      label: 'Resposta',
      field: 'answer',
      type: 'text'
    },
    {
      label: 'Consultor',
      field: 'user_id',
      type: 'text'
    },
  ]
}